import CannedCollectionModule from './CannedCollectionModule';

export * from './CannedCollectionModule';
export default CannedCollectionModule;
